export function getRequestMethod(info: RequestInfo | URL, init?: RequestInit): string {
	if (init?.method) return init.method;
	if (typeof info === 'string' || info instanceof URL) return 'GET';
	return info.method;
}
